function closeWebView() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  window.mm.ui.close({
    type: type,
    keep_top_page: 1,
    force_operation: true
  });
}
function showMessage(text) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  text && window.mm.ui.showMessage({
    status: status,
    message: text
  });
}
function openGotoPage(param) {
  window.mm.ui.openGoto({
    param: param,
    force_operation: true
  });
}
function openUrl(target, url) {
  window.mm.ui.openUrl({
    target: target,
    url: url
  });
}
var getUserInfo = function getUserInfo() {
  return new Promise(function (resolve) {
    window.mm.build({
      common: ['app', 'getUserInfo', {}, function (e) {
        resolve(e);
      }]
    });
  });
};
var dot = function dot(eventName, data) {
  console.debug('打点reportByNative参数:' + eventName, data);
  var rq = window.mm.preloader.request;
  rq('/yaahlan/game-match/momo/dm/dmEventLog', {
    eventName: eventName,
    logData: JSON.stringify(data)
  });
};
var BASE_STATUS_BAR_HEIGHT = 74;
var getStatusBarHeight = function getStatusBarHeight() {
  var statusBarHeight = localStorage.getItem('yaahlan-new-common-status-bar-height');
  if (statusBarHeight) {
    return parseInt(statusBarHeight);
  } else {
    new Promise(function () {
      window.mm.build({
        common: ['ui', 'getStatusBarHeight', {}, function (e) {
          try {
            var height = 0;
            var HEIGHT_FIX = 20;
            if ('data' in e && typeof e.data === 'string') {
              var res = JSON.parse(e.data);
              height = res.height / window.devicePixelRatio + HEIGHT_FIX;
            } else {
              height = e.height / window.devicePixelRatio + HEIGHT_FIX;
            }
            if (height < BASE_STATUS_BAR_HEIGHT) {
              height = BASE_STATUS_BAR_HEIGHT;
            }
            console.log('>>>>> getStatusBarHeight: ', height);
            localStorage.setItem('yaahlan-new-common-status-bar-height', "".concat(height));
          } catch (e) {
            console.log('>>>>> getStatusBarHeight error: ', e);
          }
        }]
      });
    });
    return BASE_STATUS_BAR_HEIGHT;
  }
};
function getNativeVersion() {
  var matchRes = navigator.userAgent.match(/momoWebView.*?\/(\d+\.\d+\.\d+).*? /);
  if (matchRes && matchRes[1]) {
    return parseInt(matchRes[1].split('.').join(''));
  } else {
    return 0;
  }
}
function getNativePatch() {
  var matchRes = navigator.userAgent.match(/momoWebView.*?\/\d+\.\d+\.\d+(.*?) /);
  if (matchRes && matchRes[1]) {
    var splitedArr = matchRes[1].split('_');
    var patch = splitedArr[splitedArr.length - 1];
    return patch;
  } else {
    return '';
  }
}
function setHtmlI18nAttr(lang) {
  document.querySelector('html').setAttribute('language', lang);
  return lang;
}
var getEnv = function getEnv() {
  var hostname = location.hostname;
  if (hostname === 'www.yaahlan.fun' || hostname === 's.immomo.com') {
    return 'prod';
  } else if (hostname === 'test-s.immomo.com') {
    return 'staging';
  } else {
    return 'dev';
  }
};
var ENV = getEnv();
var NATIVE_PATCH = getNativePatch();
var NATIVE_VERSION = getNativeVersion();
var getReuqestHost = function getReuqestHost() {
  if (ENV === 'prod') {
    return 'https://melon-gateway-os.immomo.com';
  } else {
    if (NATIVE_VERSION >= 1261) {
      return 'https://melon-gateway-alpha-stage.immomo.com';
    } else {
      return 'https://melon-gateway-stage.immomo.com';
    }
  }
};
var REQUEST_HOST = getReuqestHost();
var getMdpCreditApiOverseasHost = function getMdpCreditApiOverseasHost() {
  if (ENV === 'prod') {
    return 'https://mdp-credit-api-overseas.immomo.com';
  } else {
    if (NATIVE_VERSION >= 1261) {
      return 'https://alpha-mdp-credit-api-overseas.immomo.com';
    } else {
      return 'https://mdp-credit-api-overseas.immomo.com';
    }
  }
};
var MDP_CREDIT_API_OVERSEAS_HOST = getMdpCreditApiOverseasHost();
var getLocale = function getLocale() {
  var localeMatchRes = navigator.userAgent.match(/ lan\/(\w+)/) || [];
  var locale = localeMatchRes.length && localeMatchRes[1] || 'ar';
  if (location.hostname.includes('local') || location.hostname.includes('172')) {
    locale = 'en';
  }
  setHtmlI18nAttr(locale);
  return locale;
};
var LOCALE = getLocale();

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}

function formatNumToThousands(num) {
  var result = '',
    counter = 0;
  var numStr = (num || 0).toString();
  var _numStr$split = numStr.split('.'),
    _numStr$split2 = _slicedToArray(_numStr$split, 2),
    integer = _numStr$split2[0],
    _float = _numStr$split2[1];
  for (var i = integer.length - 1; i >= 0; i--) {
    counter++;
    result = integer.charAt(i) + result;
    if (!(counter % 3) && i != 0) {
      result = ',' + result;
    }
  }
  return result + (_float ? '.' + _float : '');
}
function formatMillisecondToStr(milliseconds) {
  var strTemplate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
  if (!milliseconds) return '';
  var date = new Date(milliseconds);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  return strTemplate.replace('YYYY', year.toString()).replace('YY', year.toString().slice(-2)).replace('MM', month.toString().padStart(2, '0')).replace('DD', day.toString().padStart(2, '0')).replace('HH', hour.toString().padStart(2, '0')).replace('mm', minute.toString().padStart(2, '0')).replace('ss', second.toString().padStart(2, '0'));
}

var getQueryString = function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return r[2];
  return null;
};
function encodeURIComponentWithDot(data) {
  return encodeURIComponent(data).replace(/\./g, '%2E');
}
function encodeSymbol(value, nowrap) {
  var s = '';
  if (!value || value.length === 0) return '';
  s = value.replace(/&/g, '&amp;');
  s = s.replace(/</g, '&lt;');
  s = s.replace(/>/g, '&gt;');
  s = s.replace(/    /g, '&nbsp;');
  s = s.replace(/'/g, '&#039;');
  s = s.replace(/"/g, '&quot;');
  if (nowrap) {
    s = s.replace(/\n/g, ' ');
  }
  return s;
}

function parseMillisecondToTimeObj(milliseconds) {
  if (!milliseconds) return null;
  var date = new Date(milliseconds);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  return {
    year: year,
    month: month,
    day: day,
    hour: hour,
    minute: minute,
    second: second
  };
}

var randomWordStrWithFixedLength = function randomWordStrWithFixedLength() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var str = '',
    range = Math.round(Math.random() * (max - min)) + min,
    arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  for (var i = 0; i < range; i += 1) {
    var pos = Math.round(Math.random() * (arr.length - 1));
    str += arr[pos];
  }
  return str;
};
var randomWordStr = function randomWordStr() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var str = 'randomWordStr';
  var arr = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  for (var i = 0; i < length; i++) {
    str += arr[Math.floor(Math.random() * arr.length)];
  }
  return str;
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
function _get(source, path) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var pathStr = path.replace(/\[(\d+)\]/g, '.$1');
  if (pathStr.startsWith('.')) {
    pathStr = pathStr.slice(1);
  }
  var paths = pathStr.split('.');
  var result = source;
  var _iterator = _createForOfIteratorHelper(paths),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;
      result = Object(result)[p];
      if (!result) {
        return defaultValue;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result !== undefined ? result : defaultValue;
}
function debounce(fn, wait) {
  var timeout = null;
  return function () {
    if (timeout !== null) clearTimeout(timeout);
    timeout = setTimeout(fn, wait);
  };
}
function throttle(fn, wait) {
  var timeout = null;
  return function () {
    if (timeout === null) {
      timeout = setTimeout(function () {
        timeout = null;
        fn();
      }, wait);
    }
  };
}
var getPlatform = function getPlatform() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  var isIOS = !!u.match(/iPhone/);
  return {
    ios: isIOS,
    android: isAndroid,
    unknown: !isIOS && !isAndroid
  };
};
var PLATFORM = getPlatform();
function isFloatEqual(a, b) {
  return Math.abs(a - b) < Number.EPSILON;
}
var useRef = function useRef(data) {
  var obj = {
    get ref() {
      return this.data.ref;
    },
    set ref(newVal) {
      this.data.ref = newVal;
    },
    data: {
      ref: data
    }
  };
  return Object.freeze(obj);
};

var loadmoreDirective = {
  bind: function bind(el, binding) {
    var fun = debounce(function () {
      binding.value();
    }, 250);
    var flag = true;
    el.addEventListener('scroll', function () {
      if (el.scrollHeight - el.offsetHeight - parseInt(binding.arg || '100') < el.scrollTop) {
        if (flag) {
          binding.value();
          flag = false;
        } else {
          fun();
        }
      }
    });
  }
};

var arDirective = {
  bind: function bind(el) {
    if (window._i18n_.isArLanguage) {
      el.classList.add('ar-transform');
    }
  },
  update: function update(el) {
    if (window._i18n_.isArLanguage) {
      el.classList.add('ar-transform');
    }
  }
};
var rtlDirective = {
  bind: function bind(el) {
    if (window._i18n_.isArLanguage) {
      el.style.direction = 'rtl';
    }
  },
  update: function update(el) {
    if (window._i18n_.isArLanguage) {
      el.style.direction = 'rtl';
    }
  }
};

function DisplayDom() {
  var _this = this;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    target = _ref.target,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? function () {} : _ref$show,
    _ref$hide = _ref.hide,
    hide = _ref$hide === void 0 ? function () {} : _ref$hide,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? 0.01 : _ref$threshold,
    _ref$once = _ref.once,
    once = _ref$once === void 0 ? false : _ref$once,
    _ref$root = _ref.root,
    root = _ref$root === void 0 ? null : _ref$root;
  threshold = Math.max(Math.min(threshold, 1), 0.01);
  try {
    var io = new window.IntersectionObserver(function (entries) {
      if (entries[0].intersectionRatio >= threshold) {
        show();
        if (once) {
          _this.stop();
        }
      } else {
        hide();
      }
    }, {
      threshold: [threshold],
      root: root
    });
    io.observe(target);
    this.stop = function () {
      io.disconnect();
    };
  } catch (error) {
    console.error(error.message, "\n\u4E0D\u652F\u6301IntersectionObserver\uFF0C\u5347\u7EA7\u6D4F\u89C8\u5668\u6216\u4EE3\u7801\u4F7F\u7528polyfill: https://github.com/w3c/IntersectionObserver");
  }
}
var vueObserverDirective = {
  inserted: function inserted(el, _ref2) {
    var value = _ref2.value,
      arg = _ref2.arg,
      modifiers = _ref2.modifiers;
    el.observer = new DisplayDom({
      target: el,
      show: typeof value === 'function' ? value : value.show,
      hide: value.hide,
      threshold: arg / 100 || undefined,
      once: modifiers.once,
      root: value.dom
    });
  },
  unbind: function unbind(el) {
    if (el.observer && typeof el.observer.stop === 'function') {
      el.observer.stop();
    }
  }
};

var clickDirective = {
  bind: function bind(el, binding) {
    var callback = binding.value || function () {};
    if (binding.modifiers.debounce) {
      callback = debounce(callback, parseInt(binding.arg || '200'));
    } else if (binding.modifiers.throttle) {
      callback = throttle(callback, parseInt(binding.arg || '200'));
    } else {
      callback = debounce(callback, parseInt(binding.arg || '200'));
    }
    el.addEventListener('click', callback);
  }
};

function initPreloader(host) {
  var VERSION = 1000;
  function _makeKey(url, params) {
    return url + '#' + JSON.stringify(sortKeys(params));
  }
  function sortKeys(target) {
    return Object.keys(target).sort().reduce(function (obj, a) {
      obj[a] = target[a];
      return obj;
    }, {});
  }
  function createGroup(desc, val) {
    var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'green';
    console.group("%c".concat(desc), "color:#fff;background:".concat(color, ";padding:2px 6px;border-radius:3px;"), val);
    console.groupEnd();
  }
  function init() {
    var preloader = {
      host: host
    };
    var data = {};
    var handler = {};
    preloader.preRequest = function (url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      params._version_ = VERSION;
      var key = _makeKey(url, params);
      console.log('preRequest', host);
      window.mm.ajax({
        host: host,
        url: url,
        data: params,
        dataType: 'json',
        success: function success(resp) {
          data[key] = resp;
          localStorage.setItem(key, JSON.stringify(resp));
          if (handler[key]) {
            if (handler[key].update) {
              handler[key].update(resp);
            }
          }
        },
        error: function error(err) {
          if (handler[key]) {
            handler[key].error(err);
            delete handler[key];
          }
        }
      });
    };
    preloader._registerHandler = function (url, params, update, error) {
      var key = _makeKey(url, params);
      handler[key] = {
        update: update,
        error: error
      };
    };
    preloader.getPreRequest = function (url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var update = arguments.length > 2 ? arguments[2] : undefined;
      var error = arguments.length > 3 ? arguments[3] : undefined;
      params._version_ = VERSION;
      var cacheMakeKey = _makeKey(url, params);
      var cache = data[cacheMakeKey];
      if (cache) {
        return update(cache);
      } else {
        var _data = localStorage.getItem(cacheMakeKey);
        _data && update(JSON.parse(_data), true);
      }
      preloader._registerHandler(url, params, update, error);
    };
    preloader.request = function (url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      params._version_ = VERSION;
      console.log('request', url, params);
      return new Promise(function (resolve, reject) {
        window.mm.ajax({
          host: host,
          url: url,
          data: params,
          dataType: 'json',
          success: function success(resp) {
            createGroup('reload', url);
            resolve(resp);
          },
          error: function error(err) {
            reject(err);
          }
        });
      });
    };
    return preloader;
  }
  window.mm.preloader = init();
}

export { BASE_STATUS_BAR_HEIGHT, ENV, LOCALE, MDP_CREDIT_API_OVERSEAS_HOST, NATIVE_PATCH, NATIVE_VERSION, PLATFORM, REQUEST_HOST, _get, arDirective, clickDirective, closeWebView, debounce, dot, encodeSymbol, encodeURIComponentWithDot, formatMillisecondToStr, formatNumToThousands, getEnv, getLocale, getNativePatch, getNativeVersion, getPlatform, getQueryString, getStatusBarHeight, getUserInfo, initPreloader, isFloatEqual, loadmoreDirective, openGotoPage, openUrl, parseMillisecondToTimeObj, randomWordStr, randomWordStrWithFixedLength, rtlDirective, setHtmlI18nAttr, showMessage, sleep, throttle, useRef, vueObserverDirective };
